import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal";
import { connect } from "react-redux";
import Button from "../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _isNil from "lodash/isNil";
import styles from "../../styles/components/Results.css";
import * as results from "../../modules/results";
import { denormalize } from "normalizr";
import { wevoSchema } from "../../schemas";

function ShareLinkSubheader({ isCopied }) {
    const classes = [
        styles.instructions,
        isCopied ? styles.copySuccessText : ""
    ];
    const text = isCopied
        ? "Link copied to clipboard!"
        : "Copy this link to share your results.";
    return (
        <p id="sub-header" className={classes.join(" ")}>
            {text}
        </p>
    );
}

export function ShareLinkButton({ onClick, isCopied }) {
    return (
        <Button
            id="copy-button"
            wrapperClass={styles.shareModalCopyButtonWrapper}
            buttonClass={styles.shareModalCopyButton}
            color={isCopied ? "success" : "primary"}
            onClick={onClick}
        >
            {isCopied ? <FontAwesomeIcon icon="check" /> : "Copy"}
        </Button>
    );
}

export class ShareLinkModal extends React.PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool,
        isCopySupported: PropTypes.bool,
        shareLink: PropTypes.string,
        closeModal: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.timerId = null;
        this.state = {
            isCopied: false
        };
    }

    onDismiss = () => {
        this.props.closeModal();
    };

    componentWillUnmount() {
        !_isNil(this.timerId) && clearTimeout(this.timerId);
    }

    onCopyClick = () => {
        if (!this.shareLinkInput) {
            return;
        }
        try {
            this.shareLinkInput.focus();
            this.shareLinkInput.select();
            document.execCommand("copy");
            this.setState({ isCopied: true });
            this.timerId = setTimeout(() => {
                this.setState({
                    isCopied: false
                });
                this.timerId = null;
            }, 3000);
        } catch (e) {
            console.error("unable to copy", { error: e });
        }
    };

    render() {
        if (!this.props.isOpen) {
            return null;
        }
        return (
            <Modal id="share-link-modal" onDismiss={this.onDismiss}>
                <div className={styles.modalContent}>
                    <h2 className={styles.withInstructions}>Share Results</h2>
                    <ShareLinkSubheader isCopied={this.state.isCopied} />
                    <div className={styles.shareModalContent}>
                        <input
                            className={styles.shareModalInput}
                            type="text"
                            value={this.props.shareLink}
                            readOnly={true}
                            ref={element => {
                                this.shareLinkInput = element;
                            }}
                        />
                        {this.props.isCopySupported && (
                            <ShareLinkButton
                                isCopied={this.state.isCopied}
                                onClick={this.onCopyClick}
                            />
                        )}
                    </div>
                </div>
            </Modal>
        );
    }
}

ShareLinkModal.propTypes = {
    wevoId: PropTypes.number.isRequired
};

export function mapStateToProps(state, props) {
    const { wevoId } = props;
    const { shareLinkModalOpen } = state.results;

    const wevo = denormalize(wevoId, wevoSchema, state.api) || null;
    const shareLinks = wevo ? wevo.shareLinks : null;

    // Create the share link to display for the WEVO. Note that this is different from props.shareLinkId, which is
    // the ID of the share link used to render this component
    let shareLink = null;
    if (window && window.location && window.location.href) {
        const url = new URL(window.location.href);
        shareLink =
            shareLinks &&
            shareLinks.length > 0 &&
            `${url.origin}/shared/${shareLinks[0]}`;
    }

    const isCopySupported =
        document &&
        document.queryCommandSupported &&
        document.queryCommandSupported("copy");
    return {
        isOpen: shareLinkModalOpen,
        isCopySupported,
        shareLink
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        closeModal: () => dispatch(results.closeShareLinkModal())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShareLinkModal);



// WEBPACK FOOTER //
// ./src/components/Results/ShareLinkModal.js